var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"cms"},[_c('app-bar',{on:{"change":function($event){return _vm.setDrawer($event)}}}),_c('drawer',{attrs:{"drawer":this.drawer}}),_c('app-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }